module.exports = __webpack_public_path__ + "media/images/ping/ping-7ddc6098904ae0d57bb5804e11cc9670.svg";